import React from 'react'
import {GridColDef} from '@mui/x-data-grid'
import {Box, Button} from '@mui/material'
import Patient from 'models/Patient'

type PatientColumnsOptions = {
  showResetPatientData?: boolean
  isLoading?: boolean
}

export const createPatientColumns = (
  onClickEdit: (patient: Patient) => void,
  onClickAddDevice: (patientId: string) => void,
  onClickDelete: (patientId: string) => void,
  onClickResetPatientData: (patientId: string) => void,
  options?: PatientColumnsOptions,
) => {
  const {showResetPatientData = false, isLoading = false} = options ?? {}
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Id',
      flex: 1,
    },
    {
      field: 'firstName',
      headerName: 'First name',
      flex: 1,
    },
    {
      field: 'lastName',
      headerName: 'Last name',
      flex: 1,
    },
    {
      field: 'physicianName',
      headerName: 'Physician name',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: '',
      hideable: false,
      disableColumnMenu: true,
      type: 'actions',
      width: showResetPatientData ? 520 : 340,
      minWidth: showResetPatientData ? 520 : 340,
      renderCell: params => (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
          <Button
            size="small"
            sx={{flexShrink: 0}}
            variant="contained"
            onClick={() => onClickAddDevice(params.id.toString())}>
            Add device
          </Button>
          <Button
            size="small"
            sx={{flexShrink: 0}}
            variant="contained"
            onClick={() => onClickEdit(params.row)}>
            Edit
          </Button>
          {showResetPatientData && (
            <Button
              size="small"
              sx={{flexShrink: 0}}
              onClick={() => {
                const confirmed = window.confirm(
                  'Are you sure you want to reset this patient data? This action cannot be undone.',
                )
                if (confirmed) {
                  onClickResetPatientData(params.id.toString())
                }
              }}
              variant="contained"
              color="warning"
              disabled={isLoading}>
              Reset Patient Data
            </Button>
          )}
          <Button
            size="small"
            sx={{flexShrink: 0}}
            onClick={() => onClickDelete(params.id.toString())}
            variant="contained"
            color="error">
            Delete
          </Button>
        </Box>
      ),
    },
  ]
  return columns
}
